import styled from "styled-components";

export const ContentContainer = styled.div`
  height: 100%;
  @media screen and (min-width: 1024px) {
    margin-left: 240px;
  }
  @media screen and (min-width: 1600px) {
    margin-left: 250px;
  }
`;

export const Content = styled.div`
  height: calc(100% - 100px);
  padding: 8px 16px;
  overflow: scroll;
  @media screen and (min-width: 1024px) {
    height: calc(100% - 50px);
  }
`;

export const Header = styled.div`
  width: 100%;
  height: 48px;
  /* border-bottom: 1px solid #dddddd; */
  margin-top: -1px;
  background: #ffffff;
  font-size: 16px;
  font-weight: bold;
  display: flex;
  align-items: center;
  padding-left: 20px;
  box-shadow: 0px 3px 5px #d1d1d1;
  background-color: #205aa7;
  color: #fff;
  margin-bottom: 10px;
  /* justify-content: center; */
`;
